module.exports = __webpack_public_path__ + "static/programmingpng-4dbda1498b0d1433849be4dc51e14c8e.png";